import { render, staticRenderFns } from "./AddServicePrice.vue?vue&type=template&id=45571846&"
import script from "./AddServicePrice.vue?vue&type=script&lang=js&"
export * from "./AddServicePrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports